window.addEventListener('load', onlineTests); //  на мобильных устройствах работает надежнее
function onlineTests() {
        // меняем класс на отвеченых
        function setAnswered(item) {
            item.removeClass('not-answered question-invalid').addClass('answered');
        }

        // проверяем все ли вопросы отвечены
        function checkIfAllAnswered() {
            var questionBlock = $('.test-body').find('.not-answered');
            if (questionBlock.length > 0) {
                questionBlock.addClass('question-invalid');

                return false;
            }
            return true;
        }

        $(document).on('click', '.not-answered .form-group label', function () {
            var item = $(this).parent().parent().parent();
            setAnswered(item);
        });

        $(document).on('click', '.check-results', function () {
            var checkResults = $('.check-results');

            if (checkIfAllAnswered() === true) {
                sendTestResults();
            } else {
                $('#modal-answer-test').modal('show');
            }
        });

        function sendTestResults() {

            var resultPoints = [];

            $.each($("input[type='radio']:checked"), function () {
                var clientAnswer = $(this).val();
                resultPoints.push(Number(clientAnswer));
            });

            var atCode = $('.online-test-body').data('attempt-code');

            location.href = '/interactivnie-testi/result?code=' + atCode + '&answers=' + JSON.stringify(resultPoints);
        }
}
